import React from 'react';
import { Link } from 'react-router-dom';
import { HOW_I_WORK_STEPS } from '../config/howIWorkContent';

function DesignProcess() {
  return (
    <section className="design-process-section" aria-labelledby="design-process-heading">
      <div className="design-process-header">
        <p id="design-process-heading" className="design-process-section-label">
          Design process
        </p>
        <Link to="/how-i-work" className="design-process-cta" aria-label="Go to how I work">
          →
        </Link>
      </div>
      <div className="design-process-cards">
        {HOW_I_WORK_STEPS.map((step) => (
          <div key={step.id} className="design-process-card-wrapper">
            <div className="design-process-card">
              <span className="design-process-card-step" aria-hidden="true">
                {step.id}
              </span>
              <h3 className="design-process-card-title">{step.title}</h3>
              <p className="design-process-card-desc">{step.tagline}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default DesignProcess;
